export default "__VITE_ASSET__ebc72f2e__"